import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PopupAnimation } from '../../../other/animations';
import { InitialToggles } from '../../../services/global/global-interfaces';

@Component({
  selector: 'sb-multi-dropdown',
  templateUrl: './sb-multi-dropdown.component.html',
  styleUrls: ['./sb-multi-dropdown.component.scss'],
  animations: [PopupAnimation],
  standalone: false,
})
export class SbMultiDropdownComponent {
  selectedItems: InitialToggles[] = [];
  _data: InitialToggles[] = [];
  @Output() dataChange = new EventEmitter<InitialToggles[]>();
  @Input() placeholder: string;
  @Input() headline: string;
  @Input() disabled: boolean;

  @Input()
  public set data(items: InitialToggles[]) {
    this._data = items;
    this.selectedItems = items.filter(item => item.value !== -1);
    this.emitData();
  }

  public get data() {
    return this._data;
  }

  constructor(public translate: TranslateService) {}

  public onItemClick(e, clickedItem: InitialToggles) {
    const foundItem = this.selectedItems.find(item => item.id === clickedItem.id);
    switch (clickedItem.value) {
      case -1: {
        clickedItem.value = 1;
        this.selectedItems.push(clickedItem);
        break;
      }
      case 0: {
        if (foundItem !== undefined) {
          foundItem.value = 1;
        }
        break;
      }
      case 1: {
        if (foundItem !== undefined) {
          foundItem.value = 0;
        }
        break;
      }
    }
    this.emitData();
  }

  public removeItem(selectedItem: InitialToggles): void {
    selectedItem.value = -1;
    const foundItemIndex = this.selectedItems.findIndex(item => item.id === selectedItem.id);
    if (foundItemIndex !== -1) {
      this.selectedItems.splice(foundItemIndex, 1);
    }
    this.emitData();
  }

  private emitData() {
    this.dataChange.emit(this.data);
  }

  public isItemSelected(selectedItem: InitialToggles): boolean {
    let found = false;
    this.selectedItems.forEach(item => {
      if (selectedItem.id === item.id) {
        found = true;
      }
    });
    return found;
  }

  public resolveColor(selectedItem: InitialToggles): string {
    switch (selectedItem.value) {
      case 0:
        return 'white red-bg';
      // case -1 : return 'grey grey-bg';
      case 1:
        return 'white green-bg';
    }
  }
}
